<template>
  <div id="top">
    <div class="all mShow">
      <!-- <Header></Header> -->
      <div class="text">
        <div class="p1">Special Reminder</div>
        <div class="outer">
          <div class="remind">
            <div v-for="item in reminds" :key="item" class="p2" v-html="item"></div>
          </div>
        </div>
      </div>
      <download></download>
      
    </div>
    <div class="pcShow">
      <div class="all pcShow">
        <!-- <Header></Header> -->
        <div class="text-pc">
          <img  src="../../assets/product-pc/camylla-battani.png" alt="">
          <div class="right">
            <div class="p1">Special Reminder</div>
            <div class="outer-box">
              <div class="suggest"  >
                <div v-for="item in reminds" :key="item" class="p2" v-html="item"></div>
              </div>
            </div>
            <!-- <div class="right-btn" @click="topdf">
              <button>next</button>
              <div class="download">Download<a-icon type="cloud-download" />
              </div>

            </div> -->
            <download></download>
          </div>
        </div>
      </div>
    </div>
    <!-- <pdf id="pa" ref="p"></pdf> -->
  </div>
</template>

<script>
import specialRemind from '../../mixins/specialRemind'
import Download from '../../components/Dowload.vue'
export default {
  mixins: [ specialRemind ],
  components: {
    Download
  },
   data () {
     return {
      reminds: []
     }
   },
   mounted() {
     // 问卷结果页曝光 埋点
    this.$sensors.track('QuestionnaireResultExpo', {
      source: 'SpecialReminder',
      hasProduct: this.$store.state.product.length > 0
    })

    // 长建议 加*做标记
    this.reminds.forEach( ( item, index ) => {
      if ( item && item.substr(0, 1) === '*' ) {
        this.reminds[index] = this.reminds[index].substr(1)
      }
    })
   }
}
</script>

<style lang="less" scoped>
#top {
  height: 100%;
  overflow: hidden;
}
img{
  width: 375px;
  height: 375px;
}
#pa {
  display: none;
}
@media only screen and (max-width: 767px) {
  .all {
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin-top: 72.5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .text {
    padding: 26px 35px 265px 30px;
    // bottom: 180px;
    height: 100%;
    // top: 72.5px;
    // position: absolute;
    .outer {
      width: 303px;
      overflow: hidden;
      height: 100%;
    }
    .remind {
      width: 310px;
      // height: 431px;
      height: 100%;
      overflow-y: auto;
    }
    .p1 {
      // width: 274px;
      height: 24px;
      margin-bottom: 10px;
      font-size: 20px;
      font-family: Helvetica-Bold, Helvetica;
      font-weight: bold;
      color: #000000;
      line-height: 24px;
    }
    .p2 {
      padding-top: 10px;
      padding-bottom: 26px;
      // width: 310px;
      // height: 420px;
      font-size: 15px;
      font-family: Helvetica-Light, Helvetica;
      font-weight: 150;
      color: #000000;
      line-height: 19px;
    }
  }
}
}
.all {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .text-pc {
    display: flex;
    // width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    img {
      width: 518px;
      height: 630px;
    }
    .right {
      padding-left: 42px;
      .outer-box {
        width: 703px;
        overflow: hidden;
      }
      .suggest {
        height: 454px;
        width: 718px;
        overflow-y: auto;
        // white-space: wrap;
      }
      .p1 {
        // width: 528px;
        height: 48px;
        margin-bottom: 20px;
        // padding-bottom: 21px;
        font-size: 40px;
        font-family: Helvetica-Bold, Helvetica;
        font-weight: bold;
        color: #000000;
        line-height: 48px;
      }
      .p2 {
        // width: 757px;
        // height: 462px;
        padding-top: 14px;
        padding-bottom: 40px;
        font-size: 24px;
        font-family: Helvetica-Light, Helvetica;
        font-weight: 300;
        color: #000000;
        line-height: 36px;
      }
      // .right-btn {
      //   margin-top: 38px;
      //   display: flex;
      //   align-items: center;
      //   justify-content: space-between;
      // }
    }
  }
  // button {
  //   border: none;
  //   // position: relative;
  //   // margin-top: 63px;
  //   // padding-top: 108;
  //   width: 360px;
  //   height: 70px;
  //   background: #E26CA5;
  //   border-radius: 72px;
  //   font-size: 17px;
  //   font-family: Helvetica-Bold, Helvetica;
  //   font-weight: bold;
  //   color: #FFFFFF;
  //   line-height: 20.5px;
  // }
  // .download {
  //   // margin-top: 12.5px;
  //   font-size: 23px;
  //   text-decoration:underline;
  //   font-family: Helvetica;
  //   color: #989898;
  //   line-height: 15.5px;
  // }
}
</style>